module.exports = __webpack_public_path__ + "img/bus.46a33568.svg";